module.exports = __webpack_public_path__ + "img/thumbnail_NorthAmericanBeaver_f_normal.33d93ab5.png";